import React from 'react';
import {injectIntl, FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

import InputAdornment from "@mui/material/InputAdornment";

import Label from "components/input/new/Label";
import InputTextField from "components/input/new/InputTextField";

import LockFieldButton from "../../../../LockFieldButton";

function SkuField(props) {
    const {values, handleChange, errors, touched, handleBlur, setFieldValue} = useFormikContext();

    return (
        <>
            <Label required htmlFor='sku'>
                <FormattedMessage id='product.show.product.form.field.sku' />
            </Label>
            <InputTextField
                name={`sku`}
                onChange={handleChange}
                value={values.sku}
                placeholder={props.intl.formatMessage({id: 'product.show.product.form.field.sku.placeholder'})}
                fullWidth
                onBlur={handleBlur}
                error={touched.sku && Boolean(errors.sku)}
                helperText={touched.sku && errors.sku}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            <LockFieldButton
                                isLocked={values.productLock?.sku}
                                onClick={() => setFieldValue('productLock.sku', !values.productLock?.sku)}
                            />
                        </InputAdornment>
                    ),
                }}
            />
        </>
    );
}

export default injectIntl(SkuField);
